import {SaleSendEmailRequest, SaleSendSMSRequest} from '~/apps/pos/models';
import * as schemas from '~/apps/pos/apis/schemas';
import * as net from '~/lib/net';
import {SaleMessageEndpoints} from '~/apps/pos/apis/endpoints';
import {getToken} from '~/apps/shared/services/token';


export async function saleSendEmailMessage(saleId, body): Promise<SaleSendEmailRequest> {
  const payload = schemas.SaleSendEmailRequest.save(body);

  return await net.apiPost(SaleMessageEndpoints.saleSendEmail(saleId), getToken(), payload);
}

export async function saleSendSmsMessage(saleId, body): Promise<SaleSendSMSRequest> {
  const payload = schemas.SaleSendSmsRequest.save(body);

  return await net.apiPost(SaleMessageEndpoints.saleSendSMS(saleId), getToken(), payload);
}

export async function salePrint(saleId): Promise<any> {
  return await net.rawRequest('GET', SaleMessageEndpoints.salePrint(saleId), getToken());
}

export async function checkoutSendText(saleId): Promise<any> {
  return await net.apiPost(SaleMessageEndpoints.checkoutSendText(saleId), getToken());
}

export async function checkoutSendEmail(saleId, email): Promise<any> {
  return await net.apiPost(SaleMessageEndpoints.checkoutSendEmail(saleId), getToken(), {email});
}
